
export enum TimePresets {
    TwoHours = "2_hours",
    FourHours = "4_hours",
    Today = "today",
    Yesterday = "yesterday"
}
